import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class NamespaceAndId {
  constructor(nameSpace, id) {
    _defineProperty(this, "_nameSpace", void 0);
    _defineProperty(this, "_id", void 0);
    this._nameSpace = nameSpace;
    this._id = id;
  }
  get nameSpace() {
    return this._nameSpace;
  }
  get id() {
    return this._id;
  }
}
//# sourceMappingURL=NamespaceAndId.js.map
